import React from 'react';
import classnames from 'classnames';

export function svgToIcon(
  svgFile: any,
  options: { className?: string } = {}
): JSX.Element {
  // We use this pattern of putting the SVG as inner HTML so that the color
  // of the SVG is controlled by the font color.

  return (
    <i
      className={classnames(`fa-regular`, options.className)}
      style={{ lineHeight: 0 }}
      dangerouslySetInnerHTML={{ __html: svgFile }}
    />
  );
}
